import { DesignWorklistPage } from "@/features/design/report-automations/ReportAutomationsDemo";
import { useNav } from "@/utils/nav";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/design/features/worklist/")({
    component: DesignWorklistRoute,
});

function DesignWorklistRoute() {
    useNav([
        { label: "Design", route: { to: "/design" } },
        { label: "Worklist", route: { to: "/design/features/worklist" } },
    ]);

    return <DesignWorklistPage />;
}
